module.exports = __webpack_public_path__ + "img/member_center_footer431008.2fb03af3.png";